import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useRef, useState, useLayoutEffect } from "react";
import { useSelectCommonActionsContext, useSelectCommonContext } from "../context/SelectContext.js";
import { Hr } from "./Hr.js";
import { Button } from "../../../Button/Button.js";
import "../../../InputControl/InputControl.js";
import "../../../InputControl/Input/InputBase.js";
import "../../../PhoneInputControl/PhoneInputControl.js";
import "../../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../IconButton/IconButton.js";
import "../../../common/ControlBody.js";
import { DialogTitle, DialogTitleText, DialogActions } from "../../../Dialog/Dialog.js";
import { IconButton } from "../../../IconButtonNew/IconButton.js";
import { LIST_ITEM_CLASSNAME } from "../../../List/ListItem/constants.js";
import { CloseIcon } from "../../../../icons/24/Action/Close.js";
import { ChevronLeftIcon } from "../../../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../../../utils/dataTestId.js";
import { CloseReasons } from "../types/enums.js";
import "./SelectInput/SelectInput.js";
import "../MultiSelect/context/MultiSelectContext.js";
import "../../../../icons/24/System/Check.js";
import "../../../../icons/24/Arrow/ChevronDown.js";
import "../../../TextareaControl/TextareaControl.js";
import "../../../SearchControl/SearchControl.js";
import "../../../../icons/24/System/Search.js";
import "../../../FormattedPhone/FormattedPhoneNumber.js";
import "../../../Avatar/styles.js";
import "../../../CheckboxGroup/Checkbox/styles.js";
import "../../../CheckboxGroup/styles.js";
import "../../../RadioGroup/Radio/styles.js";
import "../../../RadioGroup/styles.js";
import "../../../RatingButton/styles.js";
import "../../../FloatingActionButton/styles.js";
import "../../../SortingButton/styles.js";
import "../../../SquareButton/styles.js";
import "../../../Toggle/styles.js";
import { StyledDialog } from "../../../Dialog/StyledDialog.js";
import "../../../Chips/Chip/styles.js";
import "../../../ResultMarksNumber/styles.js";
import "../../../Progress/ProgressCircle/styles.js";
import "../../../Loaders/LoaderCircle/styles.js";
import "../../../Loaders/LoaderLine/styles.js";
import "../../../SegmentedControl/styles.js";
import "../../../ResultMarksText/styles.js";
import "../../../Link/styles.js";
import "../../../Tag/Tag.js";
import "../../../DatePicker/constants.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../../external/classnames/index.js";
import { Scrollbar } from "../../../Scrollbar/Scrollbar.js";
import "../../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../MobileBottomSheet/MobileBottomSheet.js";
import "../../../List/ListItem/ListItem.js";
import "../../../Nowrap.js";
import "../../../List/ListItemTree/TreeListItem.js";
import "../../../List/ListItemTree/components/Label.js";
const MobileSelectDialog = ({
  open,
  children,
  ...props
}) => /* @__PURE__ */ jsx(
  StyledDialog,
  {
    open,
    fullFrameMobile: !0,
    sx: styles.dialog,
    "data-test-id": inheritDataTestId(props, "dialog"),
    children: /* @__PURE__ */ jsx(MobileDialogBody, { ...props, children })
  }
), MobileDialogBody = ({
  handleCloseMobile,
  handleClose,
  header,
  listHeaderContent,
  listFooterContent,
  onReachEndThreshold,
  onReachEnd,
  mobileBackButton,
  children,
  ...props
}) => {
  const actions = useSelectCommonActionsContext(), ctx = useSelectCommonContext(), refClosed = useRef(!1), [initialValue] = useState(ctx == null ? void 0 : ctx.value), onDraftApply = () => {
    refClosed.current = !0, handleClose == null || handleClose(CloseReasons.APPLY);
  }, onCancel = () => {
    handleClose == null || handleClose(CloseReasons.CANCEL);
  }, rollback = () => {
    actions == null || actions.onChange({ value: initialValue });
  };
  return useLayoutEffect(() => () => {
    refClosed.current || rollback();
  }, []), /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      DialogTitle,
      {
        noContent: !0,
        sx: mobileBackButton ? { paddingX: 12 } : { paddingInlineStart: 18 },
        "data-test-id": inheritDataTestId(props, "dialog-title-row"),
        children: [
          mobileBackButton && /* @__PURE__ */ jsx(
            IconButton,
            {
              color: "quaternary",
              size: "lg",
              onClick: onCancel,
              "data-test-id": inheritDataTestId(props, "dialog-back-btn"),
              children: /* @__PURE__ */ jsx(ChevronLeftIcon, {})
            }
          ),
          /* @__PURE__ */ jsx(DialogTitleText, { sx: mobileBackButton ? { textAlign: "center" } : {}, children: header }),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              color: "quaternary",
              size: "lg",
              onClick: handleCloseMobile,
              "data-test-id": inheritDataTestId(props, "dialog-close-btn"),
              children: /* @__PURE__ */ jsx(CloseIcon, {})
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs(Stack, { sx: { minHeight: 100, flexGrow: 1 }, children: [
      listHeaderContent ? /* @__PURE__ */ jsx(Stack, { sx: styles.headerMobile, children: listHeaderContent }) : void 0,
      /* @__PURE__ */ jsx(
        Scrollbar,
        {
          "data-test-id": inheritDataTestId(props, "scrollbar"),
          onYReachThreshold: onReachEndThreshold,
          onYReachEnd: onReachEnd,
          shadow: !0,
          children
        }
      ),
      listFooterContent ? /* @__PURE__ */ jsxs(Stack, { sx: styles.footerMobile, children: [
        /* @__PURE__ */ jsx(Hr, {}),
        listFooterContent
      ] }) : void 0
    ] }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          color: "secondary",
          variant: "outlined",
          onClick: onCancel,
          "data-test-id": inheritDataTestId(props, "button-cancel"),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          color: "secondary",
          onClick: onDraftApply,
          "data-test-id": inheritDataTestId(props, "button-apply"),
          children: "Apply"
        }
      )
    ] })
  ] });
}, styles = {
  dialog: {
    [`.${LIST_ITEM_CLASSNAME}`]: {
      paddingLeft: 18
    }
  },
  footerMobile: {},
  headerMobile: {}
};
export {
  MobileSelectDialog
};
//# sourceMappingURL=MobileSelectDialog.js.map
